import { url } from "../../static/env";
import { fetchJsonWithRetry, loginShouldRetry } from "../../utils/fetchWithRetry";

export async function loginUser(phone, password, options = {}) {
  const { data } = await fetchJsonWithRetry(
    url + '/login',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone, password }),
    },
    {
      onRetryProgress: options.onRetryProgress,
      shouldRetryResponse: loginShouldRetry,
    }
  );
  console.log(data);
  return data;
}

export async function getUserData(userId, options = {}) {
  const { data } = await fetchJsonWithRetry(
    url + '/user',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId }),
    },
    { onRetryProgress: options.onRetryProgress }
  );
  console.log('getUserData', data);
  return data;
}

export async function getServices() {
  const { data, response } = await fetchJsonWithRetry(url + '/get_services', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  console.log('Received services data:', data);
  return data;
}

export async function sendPhoneCode(phone, options = {}) {
  const { data } = await fetchJsonWithRetry(
    url + '/send-phone-code',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone }),
    },
    { onRetryProgress: options.onRetryProgress }
  );
  console.log('sendPhoneCode', data);
  return data;
}

export async function verifyPhoneCode(phone, code, name, password, options = {}) {
  const { data } = await fetchJsonWithRetry(
    url + '/verify-phone-code',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone, code, name, password }),
    },
    { onRetryProgress: options.onRetryProgress }
  );
  console.log('verifyPhoneCode', data);
  return data;
}
